import {
  EnumAutoCompleteProps,
  EnumSearchFactory,
  FormikEnumSearchFactory
} from 'common/components';

type Props = {
  enumClassName: string;
  baseUrl: string;
  isFormik?: boolean;
  value?: string;
  hideEmptyOption?: boolean;
};

const EnumAutocomplete = ({
  isFormik,
  enumClassName,
  baseUrl,
  ...props
}: Props & EnumAutoCompleteProps) => {
  const Component = isFormik ? FormikEnumSearchFactory : EnumSearchFactory;

  return (
    <Component baseUrl={baseUrl} enumClassName={enumClassName} {...props} />
  );
};

export default EnumAutocomplete;
